import useIsGridPaginationEnabled from 'features/queue/newGrid/hooks/useIsGridPaginationEnabled';
import useNewQueueData from 'features/queue/newGrid/hooks/useQueueData';
import useOldQueueData from './useOldQueueData';

const useQueueData = (options) => {
    const isGridPaginationEnabled = useIsGridPaginationEnabled();
    const oldQueueData = useOldQueueData(options);
    const newQueueData = useNewQueueData(options);

    return isGridPaginationEnabled === true ? newQueueData : oldQueueData;
}

export default useQueueData;